module.exports = __webpack_public_path__ + "static/sylwiawork7-066881c0ff875ca4264d7e11ceacc93f.jpg";